export default "__VITE_ASSET__DGF8rJeM__"